import { RouteRecordRaw } from "vue-router";
import LoginPage from "@/views/LoginPage.vue";
import AdminPortal from "@/views/adminportal/AdminPortal.vue";

const adminRoutes: Array<RouteRecordRaw> = [  
    {
      path: "/admin/login",
      name: "login",
      component: LoginPage,
    },
    {
      path: "/admin",
      name: "adminportal",
      component: AdminPortal,
    },
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/userportal/subviews/AboutView.vue"),
    // },
  ];

export default adminRoutes;